import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '@shared/services/authentication.service';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { getEditorTargetUrl, validateCurrentUrl } from '@shared/utils/url-builder.utils';

export const RootRedirectGuard: CanActivateFn = async () => {
  const authService = inject(AuthenticationService);
  const hubService = inject(CurrentHubService);
  const router = inject(Router);

  const isAuth = await authService.isAuth();
  if (!isAuth) {
    return router.parseUrl('/login');
  }

  const user = await authService.getWondaUser();
  if (!user || user.Hubs.length === 0) {
    authService.clearCustomTokenCookie();
    return router.parseUrl('/createHub');
  }

  const hub = await hubService.setDefaultHub(user);

  // Only delete the custom token cookie once we know we're on the correct editor
  // domain. If we're on the wrong domain, RedirectGuard will do a
  // window.location.replace to the right one, and that domain needs the cookie
  // to be able to sign in via Firebase (localStorage is not shared across domains).
  if (validateCurrentUrl(getEditorTargetUrl(hub.mode))) {
    authService.clearCustomTokenCookie();
  }

  return router.parseUrl(`/${hub.urlTitle}`);
};
